import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const FORMATS = ['bold', 'italic', 'underline', 'list', 'bullet'];

/**
 * Compact rich-text editor for vault notes (toolbar on top).
 */
const VaultRichEditor = ({
  value = '',
  onChange,
  placeholder = 'Optional details…',
  className = '',
}) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
      clipboard: { matchVisual: false },
    }),
    []
  );

  return (
    <div className={`vault-rich-editor ${className}`.trim()}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={FORMATS}
        placeholder={placeholder}
      />
    </div>
  );
};

/** True when Quill HTML has no visible text. */
export function isEmptyRichHtml(html) {
  if (!html) return true;
  const text = String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return text.length === 0;
}

/** Strip scripts; keep Quill markup for storage. */
export function sanitizeVaultHtml(html) {
  if (isEmptyRichHtml(html)) return '';
  return String(html).replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
}

export default VaultRichEditor;
